import { tv } from 'tailwind-variants';

export const comboboxStyles = tv({
  slots: {
    base: '',
    label: 'text-sm font-medium',
    control: '',
    description: 'text-2xs text-gray-7 leading-tight',
    errorMessage: 'text-2xs text-red-6 mt-1',
    inputTrigger: '',
    buttonTrigger: 'cursor-pointer',
    dropdown: 'border-gray-2 max-h-[300px] overflow-y-auto rounded border bg-white py-2',
    search: '',
    options: '',
    option:
      'data-[selected=true]:bg-gray-0 data-[selected=true]:text-gray-9 data-[combobox-active]:bg-gray-1 data-[combobox-active]:text-gray-9 mx-2 cursor-pointer rounded px-2 py-1.5 text-sm data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50',
    empty: 'text-gray-5 py-2 text-center text-sm',
    loading: 'flex items-center justify-center py-2',
    selectedOption: 'truncate text-sm',
    placeholder: 'text-gray-5 truncate text-sm',
    separator: 'border-gray-2 my-1 border-t',
    groupLabel: 'text-gray-5 px-2 py-1.5 text-xs font-medium',
  },
});
